import { API_GETFAILEDLOGINS, API_GETUSERACTIONS, AUTH_SESSION } from "../constants";
import { axiosGet, getAuthorization } from "../utils/axios";


const EventLogApi = {
  getUserActions: async (begin: string, end: string, paginationParams: any) => {

    const headers = {
      ...getAuthorization(AUTH_SESSION),
    };

    return await axiosGet(
      API_GETUSERACTIONS,
      { begin, end, ...paginationParams },
      headers
    )
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error getUserActions:", error);
        return error.response.data;
      });
  },

  getFailedLogins: async (begin: string, end: string, paginationParams: any) => {

    const headers = {
      ...getAuthorization(AUTH_SESSION),
    };

    return await axiosGet(
      API_GETFAILEDLOGINS,
      { begin, end, ...paginationParams },
      headers
    )
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error getFailedLogins:", error);
        return error.response.data;
      });
  },
};

export default EventLogApi;
